module.exports = __webpack_public_path__ + "static/media/hospital-user.d1ab09ef.svg";